export default {
    ca: {
        title: 'Novetat!',
        title2: 'Vídeo de la jornada d\'Instamaps de 18 de maig de 2021',
        message0: 'Ja teniu disponibles al nostre canal de Youtube els vídeos corresponents a les darreres jornades en línia d\'Instamaps',
        video1:'Jornada del 26 d\'octubre de 2021',
        video2:'Jornada del 28 d\'octubre de 2021',
        message: 'Hem facilitat l\'accés als ',
        message2:'serveis web geogràfics WMS',
        message3:' del Departament de la Vicepresidència i de Polítiques Digitals i Territori.',
        message4: 'Ara, també podeu carregar de manera directa ',
        message5: 'els geoserveis WMS de l\'ICGC',
        message6: ' que contenen els diferents conjunts d\'ortofotos en curs i històriques, des de l\'any 1946 fins a les més recents encara provisionals (2021).',
        messageul1:'Visor 1 - Itinerari sensorial per la natura.',
        messageul2:'Visor 2 - Visor amb diferents formes de visualitzar informació amb dades públiques de l\'Ajuntament de Manlleu.',
        messageul3:'Visor 3 - Mapa d\'empreses i usos industrials de Gavà a partir de dades que disposa l\'ICGC i dades de l\'Ajuntament de Gavà.',
        message2_: 'Ens ajudes a fer-les a la teva mida? Només són 3 minuts.',
        message3_: 'Clica aquí ',
        message4_: 'per anar al vídeo.',
        message5_: 'Si voleu saber-ne més, accediu a ',
        emailValidation: 'L\'email és obligatori i ha de ser vàlid',
        privacyPoliciesMsg: 'Enviant el teu email acceptes',
        privacyPoliciesLink: 'la política de privacitat',
        submitSuccessMsg: 'El teu email s\'ha enviat correctament',
        submitErrorMsg: 'S\'ha produit un error enviant el teu email', 
        titleApp: 'CATALUNYA OFFLINE V2',
        messageApp: 'Estem treballant en el disseny de la versió 2 de Catalunya Offline! Les vostres aportacions ens seran de gran ajut.',
        messageApp2:'Ens vols ajudar omplint una petita enquesta? Només són 5 minuts.',
        messageApp3: 'Participa!',
        enquesta: 'Accedeix a l\'enquesta',
    },
    es: {
        title: 'Novedad!',
        title2:  'Vídeo de la Jornada en línea de Instamaps del 18 de mayo de 2021',
        message0: 'Ya están disponibles en nuestro canal de Youtube los vídeos correspondientes a las últimas jornadas online de Instamaps',
        video1:'Jornada del 26 de octubre de 2021',
        video2:'Jornada del 28 de octubre de 2021',
        message: 'Hemos facilitado el acceso a ',
        message2:'los servicios web geográficos WMS',
        message3:' del Departamento de la Vicepresidencia y Políticas Digitales y Territorio.',
        message4: 'Ahora, también puede cargar de forma directa ',
        message5: 'los geoservicios WMS del ICGC',
        message6: ' que contienen los diferentes conjuntos de ortofotos en curso e históricas, desde el año 1946 hasta las más recientes todavía provisionales (2021).',
        messageul1:'Visor 1 - Itinerario sensorial por la naturaleza.',
        messageul2:'Visor 2 - Visor con diferentes formas de visualizar información con datos públicos del Ayuntamiento de Manlleu.',
        messageul3:'Visor 3 - Mapa de empresas y usos industriales de Gavà a partir de datos que dispone el ICGC y datos del Ayuntamiento de Gavà.',
        message2_: 'Nos ayudas a hacerlas a tu medida? Sólo serán 3 minutos.',
        message3_: 'Clica aquí ',
        message4_: 'para ir al vídeo.',
        emailValidation: 'El email es obligatorio y debe ser válido',
        privacyPoliciesMsg: 'Enviando tu email aceptas',
        privacyPoliciesLink: 'la política de privacidad',
        submitSuccessMsg: 'Tu email se ha enviado correctamente',
        submitErrorMsg: 'Ha habido uin error al enviar tu email',
        titleApp: 'CATALUNYA OFFLINE V2',
        messageApp: 'Estamos trabajando en el diseño de la versión 2 de Catalunya Offline! Vuestras aportaciones nos serán de gran ayuda.',
        messageApp2: 'Nos quieres ayudar rellendando una pequeña encuesta? Sólo serán 5 minutos.',
        messageApp3: 'Participa!',
        enquesta: 'Accede a la encuesta',

    },
    en: {
        title: 'Novelty!',
        title2:  'Video of the Instamaps Online Day of May 18, 2021',
        message:'We have facilitated access to ',
        message0:'Videos from the latest Instamaps online conference are now available on our Youtube channel',
        video1:'Day of October 26, 2021',
        video2:'Day of October 28, 2021',
        message2: 'the WMS geographic web services',
        message3:' of the Department of the Vice Presidency and Digital and Territory Policies.',
        message4: 'Now, you can also directly upload ',
        message5: 'the ICGC WMS geoservices',
        message6: ' that contain the various current and historical orthophoto sets, from 1946 to the most recent yet provisional (2021).',
        message: 'On this day, the explanation of the generation of three viewers was carried out:',
        messageul1:'Viewer 1 - Sensory itinerary through nature.',
        messageul2:'Viewer 2 - Viewer with different ways of viewing information with public data from Manlleu City Council.',
        messageul3:'Viewer 3 - Map of companies and industrial uses of Gavà based on data available to the ICGC and data from Gavà City Council.',
        message2_: 'Can you help us make them to suit you? It will only be 3 minutes.',
        message3_: 'Click here ',
        message4_: 'to go to the video.',
        emailValidation: 'The email is a required field and must be valid',
        privacyPoliciesMsg: 'By sending your email you are accepting the',
        privacyPoliciesLink: 'privacy policies',
        submitSuccessMsg: 'Your email has been sent succesfully',
        submitErrorMsg: 'An error occurred while sending your email',
        titleApp: 'CATALUNYA OFFLINE V2',
        messageApp: 'We are working on the design of version 2 of Catalunya Offline! Your ENS Contributions will be of great help.',
        messageApp2: 'Do you want to help us by filling out 1 small survey? It\'s only 5 minutes.',
        messageApp3: 'Participate!',
        enquesta: 'Go to the survey',
    },
};



// WEBPACK FOOTER //
// ./src/home/components/newsletter-modal/newsletter-modal-translations.js